module.exports = __webpack_public_path__ + "flag_aus.png?eacdd6d979461a1830530935f43de4a6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flag_aus.png
// module id = 34
// module chunks = 0